

import React, { Suspense } from "react";

const Column = React.lazy(() =>
  import("@ant-design/plots").then(module => ({ default: module.Column }))
);

const ColumnChart = ({ config }) => {
  return (
    <Suspense fallback={<div>Loading chart...</div>}>
      <Column {...config} />
    </Suspense>
  );
};

export default ColumnChart;
